import {useEffect} from "react";
import axios from "axios";
import {useNavigate, useSearchParams} from "react-router-dom";
import {syncLook} from "../shared/utils/look";

const CONFIG_URL = "/os/api/provider_config/";

/**
 * The way out of a look that breaks the screens: opening any page with
 * `?estilo=padrao` puts the default look back (saved in the account too) and
 * takes the parameter out of the address.
 */
export const useLookReset = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const reset = params.get("estilo") === "padrao";

    useEffect(() => {
        if (!reset) return undefined;
        let canceled = false;
        // Show it first: the page may be unusable until it is.
        syncLook(null);
        (async () => {
            try {
                const {data} = await axios.get(CONFIG_URL);
                const [config] = data.results ?? [];
                if (config) await axios.patch(`${CONFIG_URL}${config.id}/`, {look: null});
            } catch {
                // The default is showing for now; the saved look returns on the next load.
            }
            // The account's own answer (/me/) may have just put the old look back.
            syncLook(null);
            if (canceled) return;
            const next = new URLSearchParams(window.location.search);
            next.delete("estilo");
            const query = next.toString();
            navigate(window.location.pathname + (query ? `?${query}` : ""), {replace: true});
        })();
        return () => {
            canceled = true;
        };
    }, [reset, navigate]);
};
